import { createSlice } from '@reduxjs/toolkit';

/**
 * @const {Slice} accessibilitySlice - Creates a slice of the redux store to handle
 * various bits of ui state
 */
export const accessibilitySlice = createSlice( {
    name: 'accessibilityOptions',
    /**
     * @const {Object} initialState - Setup the starting values for the store
     */
    initialState: {
        darkMode: localStorage.getItem( 'accessibility-cookie-dark-mode' ) === 'true' || localStorage.getItem( 'accessibility-cookie-dark-mode' ) === null,
        enhanceText: localStorage.getItem( 'accessibility-cookie-enhance-text' ) === 'true',
        audioDescription: localStorage.getItem( 'accessibility-cookie-audio-description' ) === 'true',
        subtitles: localStorage.getItem( 'accessibility-cookie-subtitles' ) === 'true'
    },
    reducers: {
        /**
         * Update the theme of site to be light or dark
         * @param {Object} state - The current state of the store
         * @param {Object} action - The action object, the payload should be a boolean
         */
        setDarkMode: ( state, action ) => {
            document.body.dataset.theme = action.payload ? 'dark' : 'light';
            state.darkMode = action.payload;
        },
        /**
         * Update the theme of site to be light or dark
         * @param {Object} state - The current state of the store
         * @param {Object} action - The action object, the payload should be a boolean
         */
        setEnhanceText: ( state, action ) => {
            document.body.dataset.enlarge = action.payload ? 'true' : 'false';
            state.enhanceText = action.payload;
        },
        /**
         * Update the theme of site to be light or dark
         * @param {Object} state - The current state of the store
         * @param {Object} action - The action object, the payload should be a boolean
         */
        setAudioDescription: ( state, action ) => {
            state.audioDescription = action.payload;
        },
        /**
         * Update the theme of site to be light or dark
         * @param {Object} state - The current state of the store
         * @param {Object} action - The action object, the payload should be a boolean
         */
        setSubtitles: ( state, action ) => {
            state.subtitles = action.payload;
        }
    }
} );

export const getDarkMode = state => state.accessibilityOptions.darkMode;
export const getAccessibilityOptions = state => state.accessibilityOptions;

export const { setDarkMode, setEnhanceText, setAudioDescription, setSubtitles } = accessibilitySlice.actions;

export default accessibilitySlice.reducer;
